module.exports = __webpack_public_path__ + "static/rbox-phone-9daf24ed829bf5a49c548e54a9ad9bd2.png";